import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Grid
} from './../../../components'
import {
  TableActionWrapper
} from './styled'

class TableActionRight extends React.PureComponent {
  render() {
    const {
      className,
      children
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'table-action-right',
      className
    )

    return (
      <Grid.Column className={classes}>
        {children}
      </Grid.Column>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}

class TableActionLeft extends React.PureComponent {
  render () {
    const {
      className,
      children
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'table-action-left',
      className
    )

    return (
      <Grid.Column className={classes}>
        {children}
      </Grid.Column>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}

export class TableAction extends React.PureComponent {
  render () {
    const {
      className,
      children
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'table-action',
      className
    )

    return (
      <TableActionWrapper className={classes}>
        <Grid justify='space-between'>
          {children}
        </Grid>
      </TableActionWrapper>
    )
  }

  static Right = TableActionRight
  static Left = TableActionLeft

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
